import React, { Component } from "react";
import { Link } from "react-router-dom";
import EmployeeService from "../Services/EmployeeService";

class Employeelist extends Component {

    constructor(props) {

        super(props);
        this.state = {
            employees: [],
            search: ''
        }

        this.deleteEmployee = this.deleteEmployee.bind(this);
        this.searchEmployee = this.searchEmployee.bind(this);
        // this.helper = this.helper.bind(this);
    }
    componentDidMount() {

        EmployeeService.getEmployees().then((res) => {
            console.log(res.data);
            this.setState({ employees: res.data });
        })

    }
    helper(query) {
        this.searchEmployee(query);
    }
    deleteEmployee(id) {

        EmployeeService.deleteEmployee(id).then((res) => {
            console.log(res);
            window.location.reload();

        });
    }
    searchEmployee(query) {

        EmployeeService.searchEmployee(query).then((res) => {

            this.setState({ employees: res.data });

        });
    }
    changeSearch = (event) => {
        this.setState({ search: event.target.value });
    }

    render() {

        return (
            <div style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '80%', margin: 'auto' }}>
                <h2 className="text-center">Employee List</h2>
                <div className="add-page" >
                    <Link to={"/create"} >
                        <button className="btn btn-primary" >Add Employee</button>
                    </Link>
                </div>
                <div style={{ margin: "10px" }}>
                    <input type="search" placeholder="search" value={this.state.search} onChange={this.changeSearch} />
                    <button style={{ backgroundColor: "yellowgreen" }} onClick={() => this.helper(this.state.search)}>Search</button>
                </div>
                <div className="row" >
                    <table className="table table-striped table-bordered" style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '80%', margin: 'auto' }}>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Mobile No.</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                this.state.employees.map(
                                    e =>

                                        <tr key={e.emp_id}>
                                            <td>{e.emp_id}</td>
                                            <td>{e.first_name}</td>
                                            <td>{e.last_name}</td>
                                            <td>{e.mobile}</td>
                                            <td>{e.email}</td>
                                            <td>{e.address}</td>
                                            <td>
                                                <Link to={"/update-employee/:id=" + e.emp_id}>
                                                    <button type="button" class="btn btn-primary" style={{ marginRight: '10px' }}>Edit</button></Link>
                                                <button type="button" class="btn btn-danger" onClick={() => this.deleteEmployee(e.emp_id)} style={{ marginRight: '10px' }}>Delete</button>
                                                <Link to={"/view-employee/:id=" + e.emp_id}>
                                                    <button type="button" class="btn btn-dark">View</button>
                                                </Link>
                                            </td>
                                        </tr>
                                )
                            }
                        </tbody>
                    </table>

                </div>
            </div>
        );
    }
}

export default Employeelist;
